import { useState, useEffect } from 'react'
import { FormSteps } from './prompt-steps/FormSteps'
import { PromptPreview } from './prompt-steps/PromptPreview'
import { usePromptForm } from '@/hooks/usePromptForm'
import { PasteHandler } from './prompt-steps/PasteHandler'
import { DialogWrapper } from './prompt-steps/DialogWrapper'

interface PromptStepFormProps {
  promptTemplate: string;
}

export const PromptStepForm = ({ promptTemplate }: PromptStepFormProps) => {
  const [open, setOpen] = useState(false)
  const {
    step,
    showPreview,
    finalPrompt,
    values,
    uploading,
    uploadedFiles,
    handleInputChange,
    handleInputFileChange,
    handleRemoveFile,
    handleNext,
    handleUpdatePrompt,
    handleProceed,
    resetForm
  } = usePromptForm(promptTemplate)

  const handlePastedFile = async (file: File) => {
    const syntheticEvent = {
      target: { files: [file] },
      preventDefault: () => {},
      stopPropagation: () => {},
      nativeEvent: new Event('change'),
      currentTarget: null,
      bubbles: true,
      cancelable: true,
      defaultPrevented: false,
      eventPhase: 0,
      isTrusted: true,
      timeStamp: Date.now(),
      type: 'change',
      isDefaultPrevented: () => false,
      isPropagationStopped: () => false,
      persist: () => {},
    } as unknown as React.ChangeEvent<HTMLInputElement>
    
    await handleInputFileChange(syntheticEvent)
  }

  useEffect(() => {
    const handleKeyPress = (event: KeyboardEvent) => {
      if (event.key === 'Enter' && open && !event.shiftKey) {
        event.preventDefault()
        if (showPreview) {
          handleProceed()
        } else {
          handleNext()
        }
      }
    }

    if (open) {
      window.addEventListener('keydown', handleKeyPress)
    }

    return () => {
      window.removeEventListener('keydown', handleKeyPress)
    }
  }, [open, showPreview, handleNext, handleProceed])

  return (
    <DialogWrapper
      open={open}
      onOpenChange={setOpen}
      onReset={resetForm}
    >
      <PasteHandler
        enabled={open && step === 3}
        onPaste={handlePastedFile}
      />
      {!showPreview ? (
        <FormSteps
          currentStep={step}
          values={values}
          uploading={uploading}
          uploadedFiles={uploadedFiles}
          onInputChange={handleInputChange}
          onFileChange={handleInputFileChange}
          onRemoveFile={handleRemoveFile}
          onNext={handleNext}
        />
      ) : (
        <PromptPreview
          prompt={finalPrompt}
          uploadedFiles={uploadedFiles}
          onProceed={handleProceed}
          onUpdatePrompt={handleUpdatePrompt}
          onRemoveFile={handleRemoveFile}
        />
      )}
    </DialogWrapper>
  )
}